import useConfig from '@sdk/config/useConfig';
import useAuth from '@sdk/authentication/useAuth';
import { isFeatureEnabled } from '@sdk/utils/isFeatureEnabled';

export const useIsAttestationsFeatureFlagEnabled = () => {
  const {
    FEATURE_FLAGS: { AUTOMATED_BREAKS, AUTOMATED_BREAKS_ATTESTATIONS },
  } = useConfig();

  const { currentUser } = useAuth();

  return (
    isFeatureEnabled(AUTOMATED_BREAKS, currentUser.org.id) &&
    isFeatureEnabled(AUTOMATED_BREAKS_ATTESTATIONS, currentUser.org.id)
  );
};
